export enum NetworkStatus {
    Unknown = 'Unknown',
    Offline = 'Offline',
    Online = 'Online',
}
